export const SaveFieldMixin = {
    data: () => ({
        field: null,
    }),

    methods: {
        /**
         * Rewrites reference to a variable, so our modal can catch it
         *
         * @param {DynamicField} field
         */
        setFieldReference(field) {
            this.field = field;
        },
        /**
         * Processes field save, and transition to the edit state
         *
         * @param {DynamicField} field
         */
        saveFieldCallback(field) {
            if (this.field) {
                if (field.label) {
                    this.$set(this.field, 'label', field.label);
                }

                if (field.text) {
                    this.$set(this.field, 'text', field.text);
                }

                if (field.content) {
                    this.$set(this.field, 'content', field.content);
                }

                if (field.fp_ext_ids) {
                    this.$set(this.field, 'fp_ext_ids', field.fp_ext_ids);
                }
            }

            this.$emit('saveField', this.field ? {} : { field, postAction: this.setFieldReference });
        },
        /**
         * Breaks managed field reference
         *
         * @return void
         */
        breakFieldReference() {
            this.field = null;
        }
    }
};
